<template>
  <li class="nav-sub-group nav-sub-dropdown" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-sub-group-dropdown-title nav-sub-group-title" @click="toggled = !toggled" id="blueprints-button" :aria-expanded="toggled" aria-controls="blueprints-expanded">
      <i class="k-asset-icon fa-duotone fa-compass-drafting" aria-hidden="true"></i>
      <span>Blueprints</span>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </button>
    <ul class="third-level" id="blueprints-expanded" aria-labelledby="blueprints-button" :hidden="!toggled">
      <li class="third-level-nav-sub-group">
        <div class="nav-third-level-title">
          <router-link :to="{ name: 'curriculum_blueprints_programmes'}">
            <span>Programmes</span>
          </router-link>
        </div>
      </li>
    </ul>
  </li>
</template>

<style scoped>
.third-level-nav-sub-group {
  list-style: none;
}

</style>

<script>
export default {
  data() {
    return {
      toggled: false,
    };
  },
};
</script>
